import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Logo from "../../../assets/LOGO_bg.png";
import swal from "sweetalert";
import { useSelector, useDispatch } from "react-redux";
import { AUTH_LOGIN, HANDLE_ERROR } from "../../../services/auth/actionTypes";
import { authLogin } from "../../../services/auth/actions";
import "./style.scss";
import Loader from "../../../components/Loader2";

const Login = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { user, isLoading, error } = useSelector(({ authState }) => ({
    user: authState.user,
    isLoading: authState.isLoading,
    error: authState.error,
  }));
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });

  const updateFields = (e) => {
    setCredentials((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const login = () => {
    if (credentials.email.length === 0 || credentials.password.length === 0) {
      swal("Form Error", "Please fill email & password correctly", "warning");
    } else {
      localStorage.setItem("email", credentials.email);
      dispatch(authLogin(credentials));
    }
  };

  useEffect(() => {
    if (error) {
      swal("Server Error", error.message || "Unkown Error Occurred", "error");
      dispatch({ type: HANDLE_ERROR, error: null });
    }
  }, [error, dispatch]);

  useEffect(() => {
    if (user) {
      if (user.accessToken) {
        window.localStorage.setItem("user", JSON.stringify(user));
        history.push("/dashboard");
      }
    } else {
      let local = JSON.parse(localStorage.getItem("user"));
      if (local) {
        dispatch({ type: AUTH_LOGIN, payload: local });
      }
    }
  }, [user, history, dispatch]);

  return (
    <div className="login_container" style={{ height: window.innerHeight }}>
      <div className="login_box">
        {/* Logo */}
        <div className="logo">
          <img src={Logo} alt="bevoice" />
        </div>
        {/* Vertical Seperator */}
        <div className="vertical_seperator"></div>
        {/* Main form */}
        <div className="login_form">
          {/* Titles */}
          <div>
            <div className="title">Welcome to Bevoice!</div>
            <div className="subtitle">
              To enojoy our journey, please insert your e-mail and password.
            </div>
          </div>
          <div>
            {/* Email / Password Inputs */}
            <input
              type="email"
              name="email"
              id="login_email"
              placeholder="E-MAIL"
              onChange={updateFields}
            />
            <input
              type="password"
              name="password"
              id="login_password"
              placeholder="PASSWORD"
              onChange={updateFields}
            />
            <div className="login_form_helper">
              {/* Reset & Forgot */}
              <span id="remember_me">
                <input
                  type="checkbox"
                  name="remember_me"
                  id="remember_me_input"
                  value="Remeber"
                />
                <label htmlFor="remember_me_input">Remember me</label>
              </span>
              <button
                id="forgot_password"
                onClick={() => history.push("/reset-password")}
              >
                Forgot Password?
              </button>
            </div>
          </div>
          <div className="login_buttons">
            {/* Login & Register buttons */}
            <button id="register_btn" onClick={() => history.push("/register")}>
              Register
            </button>
            <button id="login_btn" onClick={() => login()}>
              {isLoading ? <Loader size="sm" color="#fff" /> : "Login"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
